import React from 'react';
import i18n from 'i18n';
import { getLogout } from 'api';
import { loggedOut } from '_common/reducers/auth';
import { useAppDispatch, useAppSelector } from '_common/hooks/reduxHooks';
import { Page } from '@components/page';

const LogoutPage = () => {
  const dispatch = useAppDispatch();

  const isAuthenticated = useAppSelector(({ auth: { authenticated } }) => {
    return authenticated;
  });

  React.useEffect(() => {
    if (isAuthenticated) {
      getLogout({}).then(() => {
        dispatch(loggedOut());
      });
    }
  }, [isAuthenticated]);

  if (!isAuthenticated) {
    window.location.href = '/';
  }

  return <Page>{i18n.t('common:LoggingOut')}</Page>;
};

export default LogoutPage;
